import React from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'

import InfoBlock from '../components/InfoBlock'
import { IssueEntity } from '../../types/IssueEntity'
import { Link } from 'react-router'

interface IssueSellers {
    issueSellers: IssueEntity['investors']
}

const compareByName = (a, b) => {
    if (a.name < b.name) {
        return -1
    }
    if (a.name > b.name) {
        return 1
    }
    return 0
}

function IssueSellers({ issueSellers }: IssueSellers) {
    if (issueSellers.length === 0) {
        return null
    }

    return (
        <InfoBlock title='Säljande aktieägare'>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Ägare</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {issueSellers.sort(compareByName).map((investor) => (
                            <TableRow key={investor.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell>
                                    <Link to={`/investors/${investor.investorId}`}>{investor.name}</Link>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </InfoBlock>
    )
}

export default IssueSellers
